import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import {
    SenderKYC as EKYC_INITIATE,
    VerifySenderKYC as EKYC_VALIDATE
} from 'Components/Api/EKYCAPI';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import Box from '@material-ui/core/Box';
import { OTPModal } from 'Components/Modal/OTPModal';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useLocation } from 'react-router-dom';

const CustomContainer = HOCLoader(Container);

const SendereKYC = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [responseMessage, setResponseMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [eKYCMasterID, seteKYCMasterID] = useState(0);
    const [openOTP, setOpenOTP] = useState(false);
    const [isError, setIsError] = useState(false);
    const location = useLocation();
    const MobileNumber = location?.state?.Mobile;
    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }
        setFormObj(values);
        let jsonObj = {
            MobileNumber: MobileNumber,
            Aadhaar: values.Aadhaar,
        };
        var requestObj = JSON.stringify(jsonObj); 
        setIsError(false);
        setLoading(true);
        const response = await EKYC_INITIATE(requestObj); 
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            setOpenOTP(false);
            if (response.data === "You have already kyc done, no need kyc") {
                history.push('/KYCPPI_SenderSearch');
                return;
            }
            return;
        }
        let data = JSON.parse(response.data);
        setSeverity('success');
        setResponseMessage(data.Message);
        seteKYCMasterID(data.eKYCMasterID);
        setIsError(true);
        setOpenOTP(true);
        if (data === 'You have already kyc done, no need kyc') {
            history.push('/KYCPPI_SenderSearch');
            return;
        }
        return;
    };


    const [FormObj, setFormObj] = useState({
        Aadhaar: ''
    });

    const FormValidationSchema = Yup.object({
        Aadhaar: Yup.string()
            .length(12, 'Must be 12 digit')
            .required(PLEASE_PROVIDE_VALID + ' aadhaar'),
    });

    const VerifyOTP = async (otpObj) => {
        setLoading(true);
        setOpenOTP(false);

        const { OTP } = otpObj;

        let RequestObj = {
            OTP: OTP,
            eKYCMasterID: eKYCMasterID,
            MobileNumber: MobileNumber
        };
        var response = await EKYC_VALIDATE(JSON.stringify(RequestObj));
        setLoading(false);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            setOpenOTP(true);
            return;
        }
        let data = JSON.parse(response.data);
        var param_2 = {
            Mobile: MobileNumber,
            Name: data.AadharName,
            Pincode: data.Pin,
            Address: data.Address,
            IsKYC: "true"
        };

        setSeverity('success');
        setIsError(true);
        setOpenOTP(false);
        setResponseAlert(data);
        setIsResponseAlertOpen(true);

        if (data.Message && data.Message.toLowerCase() === 'you have already kyc done, no need kyc') {
            history.push('/KYCPPI_SenderSearch');
        } else {
            history.push('/KYCPPI_SenderRegistration', param_2);
        }

    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={FormObj}
                render={({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <Grid
                                item
                                container
                                margin="normal"
                                xs={12}
                                md={12}
                                sm={12}
                                lg={12}
                                spacing={2}
                                style={{ justifyContent: 'center' }}
                            >
                                <Grid item xs={12} sm={12} md={4} lg={4}>
                                    <h2 className={classes.PaperHead_h2}>
                                        Sender eKYC
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>

                                                <Grid
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{ marginBottom: '16px' }}
                                                >
                                                    <MaterialNumberField
                                                        label="Aadhaar"
                                                        name="Aadhaar"
                                                        length="12"
                                                        placeholder="Aadhaar"
                                                        title="Aadhaar"
                                                    />

                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div className={classes.SubmitWrapper}>
                                                <Button
                                                    type="submit"
                                                    title="Generate OTP"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Generate OTP
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            />
            {openOTP ? (
                <OTPModal
                    isOpen={openOTP}
                    title="OTP"
                    error={responseMessage}
                    submitCallback={(value) => {
                        VerifyOTP(value);
                    }}
                    resendCallback={(value) => { }}
                    onDismissCallback={(value) => {
                        setOpenOTP(value);
                    }}
                />
            ) : null}
        </CustomContainer >
    );
};

export default SendereKYC;
